import { render, staticRenderFns } from "./UpcomingDiscussionItem.vue?vue&type=template&id=37296894&scoped=true"
import script from "./UpcomingDiscussionItem.vue?vue&type=script&lang=ts"
export * from "./UpcomingDiscussionItem.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingDiscussionItem.vue?vue&type=style&index=0&id=37296894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37296894",
  null
  
)

export default component.exports